<template>
  <div class="page-card">
    <h2 class="page-title">个人中心</h2>

    <el-row :gutter="20">
      <el-col :span="14">
        <el-card shadow="never">
          <el-descriptions :column="2" border>
            <el-descriptions-item label="账号">{{ adminInfo && adminInfo.username }}</el-descriptions-item>
            <el-descriptions-item label="姓名">{{ adminName }}</el-descriptions-item>
            <el-descriptions-item label="用户ID">{{ adminInfo && adminInfo.userId }}</el-descriptions-item>
            <el-descriptions-item label="身份">平台管理员</el-descriptions-item>
          </el-descriptions>
        </el-card>

        <el-card shadow="never" class="password-card">
          <div slot="header">修改密码</div>
          <el-form
            ref="passwordForm"
            :model="passwordForm"
            :rules="passwordRules"
            label-width="110px"
            class="password-form"
          >
            <el-form-item label="旧密码" prop="oldPassword">
              <el-input v-model="passwordForm.oldPassword" type="password" show-password placeholder="请输入旧密码" />
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
              <el-input v-model="passwordForm.newPassword" type="password" show-password placeholder="请输入6-20位新密码" />
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassword">
              <el-input v-model="passwordForm.confirmPassword" type="password" show-password placeholder="请再次输入新密码" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="submittingPassword" @click="submitPassword">确认修改</el-button>
              <el-button @click="resetPasswordForm">重置</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>

      <el-col :span="10">
        <el-card shadow="never" class="logo-card">
          <div slot="header">平台 Logo</div>
          <div class="logo-preview-wrap">
            <div class="logo-preview">
              <img v-if="logoImageUrl" :src="logoImageUrl" alt="logo" class="logo-image">
              <div v-else class="logo-placeholder">TA</div>
            </div>
            <div class="logo-actions">
              <el-upload
                action="#"
                :show-file-list="false"
                :http-request="handleLogoUpload"
                accept="image/png,image/jpeg,image/jpg,image/webp"
              >
                <el-button type="primary">上传 Logo</el-button>
              </el-upload>
              <el-button v-if="logoImageUrl" @click="clearLogo">移除 Logo</el-button>
            </div>
            <div class="logo-tip">支持 PNG/JPG/JPEG/WEBP，建议使用正方形图片，大小不超过 2MB。</div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { changeAdminPassword } from '../../api/auth'

export default {
  name: 'ProfilePage',
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入确认密码'))
        return
      }
      if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次新密码输入不一致'))
        return
      }
      callback()
    }
    const validateNewPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入新密码'))
        return
      }
      if (value.length < 6 || value.length > 20) {
        callback(new Error('新密码长度必须为6-20位'))
        return
      }
      if (value === this.passwordForm.oldPassword) {
        callback(new Error('新密码不能与旧密码相同'))
        return
      }
      callback()
    }
    return {
      submittingPassword: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        oldPassword: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        newPassword: [{ validator: validateNewPassword, trigger: 'blur' }],
        confirmPassword: [{ validator: validateConfirmPassword, trigger: 'blur' }]
      }
    }
  },
  computed: {
    adminInfo() {
      return this.$store.state.adminInfo
    },
    adminName() {
      return this.$store.getters.adminName
    },
    logoImageUrl() {
      return (this.$store.getters.layoutSettings && this.$store.getters.layoutSettings.logoImageUrl) || ''
    }
  },
  methods: {
    saveLogoImage(url) {
      this.$store.dispatch('saveLayoutSettings', {
        logoImageUrl: url || ''
      })
    },
    clearLogo() {
      this.saveLogoImage('')
      this.$message.success('Logo 已移除')
    },
    handleLogoUpload(option) {
      const file = option && option.file
      if (!file) {
        return
      }
      const isImage = /^image\/(png|jpeg|jpg|webp)$/.test(file.type)
      if (!isImage) {
        this.$message.error('仅支持 PNG/JPG/JPEG/WEBP 图片')
        return
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('Logo 图片大小不能超过 2MB')
        return
      }

      const reader = new FileReader()
      reader.onload = () => {
        this.saveLogoImage(reader.result)
        this.$message.success('Logo 上传成功')
        if (option.onSuccess) {
          option.onSuccess({ url: reader.result })
        }
      }
      reader.onerror = () => {
        this.$message.error('Logo 读取失败')
        if (option.onError) {
          option.onError(new Error('file read failed'))
        }
      }
      reader.readAsDataURL(file)
    },
    resetPasswordForm() {
      this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
      if (this.$refs.passwordForm) {
        this.$refs.passwordForm.clearValidate()
      }
    },
    submitPassword() {
      this.$refs.passwordForm.validate(async valid => {
        if (!valid || this.submittingPassword) {
          return
        }
        try {
          this.submittingPassword = true
          await changeAdminPassword(this.passwordForm)
          this.$message.success('密码修改成功，请重新登录')
          this.resetPasswordForm()
          this.$store.dispatch('logout')
          this.$router.replace('/login')
        } catch (error) {
          this.$message.error(error.message || '修改密码失败')
        } finally {
          this.submittingPassword = false
        }
      })
    }
  }
}
</script>

<style scoped>
.password-card {
  margin-top: 20px;
}

.password-form {
  max-width: 520px;
}

.logo-card {
  height: 100%;
}

.logo-preview-wrap {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.logo-preview {
  width: 132px;
  height: 132px;
  border-radius: 16px;
  background: #f5f7fa;
  border: 1px dashed #dcdfe6;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.logo-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.logo-placeholder {
  font-size: 28px;
  font-weight: 700;
  color: #409eff;
}

.logo-actions {
  display: flex;
  gap: 12px;
}

.logo-tip {
  font-size: 12px;
  line-height: 1.6;
  color: #909399;
}
</style>
